export const LAYERS = {
  BLOOM: 1,
  POILabel: 2,
  /** Focused planet + moons/rings; matches the sun spotlight so fill lighting does not wash out shadows. */
  SUN_SPOT: 3,
};
